module.exports = __webpack_public_path__ + "img/promo-slide.caafa71b.jpg";